import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from './system.service';
import { delay, finalize } from 'rxjs/operators';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(
    private systemService: SystemService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // only handle backend calls
    if(!request.url.includes('/api')) { return next.handle(request); }

    this.systemService.loading$.next(true);
    console.log('interceptor loading: ', true)

    return next.handle(request)
      .pipe(        
        finalize(() => {
          this.systemService.loading$.next(false)
          console.log('interceptor loading: ', false)
        })
      );
  }
}
